import { ClockIcon } from '@fingertip/icons'
import { useTranslation } from 'react-i18next'

import { ConditionalWrapper } from '@/components/shared/conditional-wrapper'
import { TooltipWrapper } from '@/components/shared/tooltip-wrapper'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { durationDisplay } from '@/lib/utils/date-display'

type Props = {
  duration: number
  className?: string
  isCustom?: boolean
}

export const EventDurationBadge = ({
  duration,
  className,
  isCustom,
}: Props) => {
  const { t } = useTranslation()

  return (
    <ConditionalWrapper
      condition={!!isCustom}
      wrapper={(children) => {
        return (
          <TooltipWrapper message={t('Custom duration applied')}>
            {children}
          </TooltipWrapper>
        )
      }}
    >
      <Badge className={cn('h-9 p-2 text-sm', className)}>
        <ClockIcon className="mr-1 size-4 shrink-0" />
        {durationDisplay(duration, 'short')}
        {isCustom && ' *'}
      </Badge>
    </ConditionalWrapper>
  )
}
